var map = {
	"./VID-20241122-WA0109.mp4": 498,
	"./VID-20241123-WA0012.mp4": 680,
	"./VID-20241123-WA0013.mp4": 2045,
	"./VID-20241123-WA0014.mp4": 6814,
	"./VID-20241123-WA0015.mp4": 1651,
	"./VID-20241123-WA0016.mp4": 188,
	"./VID-20241123-WA0017.mp4": 4145,
	"./VID-20241123-WA0018.mp4": 1698,
	"./VID-20241123-WA0019.mp4": 1799,
	"./VID-20241123-WA0020.mp4": 4471,
	"./VID-20241123-WA0021.mp4": 3746,
	"./VID-20241123-WA0022.mp4": 7941,
	"./VID-20241123-WA0023.mp4": 5328,
	"./VID-20241123-WA0024.mp4": 5707,
	"./VID-20241123-WA0025.mp4": 5286,
	"./VID-20241123-WA0026.mp4": 2233,
	"./VID-20241123-WA0027.mp4": 2052,
	"./VID-20241123-WA0028.mp4": 5583,
	"./VID-20241123-WA0029.mp4": 6074,
	"./VID-20241123-WA0030.mp4": 4192,
	"./VID-20241123-WA0031.mp4": 7269,
	"./VID-20241123-WA0032.mp4": 9058,
	"./VID-20241123-WA0033.mp4": 2343,
	"./VID-20241123-WA0034.mp4": 3444,
	"./VID-20241123-WA0035.mp4": 8041,
	"./VID-20241123-WA0036.mp4": 7606,
	"./VID-20241123-WA0037.mp4": 4571,
	"./VID-20241123-WA0038.mp4": 7560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6746;